import $ from 'jquery'
import CM from 'codemirror';
import 'codemirror/lib/codemirror.css';
import 'codemirror/addon/edit/matchbrackets.js';
import 'codemirror/addon/lint/lint.js';
import 'codemirror/addon/lint/lint.css';
import 'codemirror/mode/clike/clike.js';
import './index.html';
import './style.css';

const fileExtensionsToMimeTypes = {
    'java': 'text/x-java',
    'c': 'text/x-csrc',
    'h': 'text/x-chdr',
    'cc': 'text/x-c++src',
    'cpp': 'text/x-c++src',
    'c++': 'text/x-c++src',
    'hh': 'text/x-c++hdr',
    'hpp': 'text/x-c++hdr',
    'h++': 'text/x-c++hdr',
    'm': 'text/x-objectivec',
};

const editors = $('.editors');
const issueList = $('.issues');

const files = {};

const enablerArrowColor = '#000099';
const precursorArrowColors = ['green', 'darksalmon', 'darkolivegreen', 'deeppink'];
const trailArrowColor = '#999999';
const informerArrowColor = '#cccc00';

CM.registerHelper('lint', 'clike', (_src, _options, editor) => editor.issues);

const data = await $.getJSON('data.json');

function makeCodeMirror(name, contents) {
    const extension = name.substring(name.lastIndexOf('.') + 1);
    editors.append(`<h3>${name}</h3>`);
    const cm = CM(editors[0], {
        lineNumbers: true,
        autofocus: true,
        matchBracket: true,
        readOnly: true,
        gutters: ['CodeMirror-lint-markers'],
        mode: fileExtensionsToMimeTypes[extension],
        value: contents,
        viewportMargin: Infinity // For the overlay canvas showing arrows
    });
    const lineDiv = cm.display.lineDiv;
    const canvas = document.createElement('canvas');
    canvas.width = lineDiv.offsetWidth;
    canvas.height = lineDiv.offsetHeight;
    canvas.style.zIndex = 10;
    canvas.style.position = 'absolute';
    lineDiv.parentElement.insertBefore(canvas, lineDiv);
    const ctx = canvas.getContext('2d');
    cm.drawingCtx = ctx;
    return cm;
}

function cmBegin(begin) {
    return CM.Pos(begin.line - 1, begin.column - 1);
}

function cmEnd(end) {
    return CM.Pos(end.line - 1, end.column);
}

function cmSmartEnd(loc, cm) {
    var end = cmEnd(loc.end);
    end.ch = cm.getTokenAt(end).end;
    return end;
}

function cmSmartSpan(loc) {
    const cm = files[loc.file];
    return {begin: cmBegin(loc.begin), end: cmSmartEnd(loc, cm)};
}

let markedEnablers = [];

function getSourceFor(item) {
    const {begin, end} = cmSmartSpan(item.location);
    const cm = files[item.location.file];
    return cm.getRange(begin, end);
}

function makeEnablerBox(issue, enabler, trail, span, labelStyle) {
    const content = $('<div class="issue"/>');
    const enablerSpan = $('<span/>');
    enablerSpan.text(getSourceFor(enabler));
    enablerSpan.addClass(labelStyle);
    enablerSpan.addClass('enabler');
    content.append(enablerSpan);
    return makeDependencyBox(issue, enabler, trail, span, content);
}

function makePrecursorBox(issue, precursorUse, precursorDef, trail, span, colorCode) {
    const content = $('<div class="issue"/>');
    const useSpan = $(`<span class="precursor-mention${colorCode}"/>`);
    useSpan.text(getSourceFor(precursorUse));
    const descrDiv = $('<div class="precursor-descr"/>');
    descrDiv.text(precursorUse.descr + ':');
    const useDiv = $('<div/>');
    useDiv.append('Use: ');
    useDiv.append(useSpan);
    const defSpan = $(`<span class="precursor-definition${colorCode}"/>`);
    defSpan.text(getSourceFor(precursorDef));
    const defDiv = $('<div/>');
    defDiv.append('Definition: ');
    defDiv.append(defSpan);
    const valDiv = $('<div class="example-value"/>');
    if (precursorDef.exampleValue !== null) {
        valDiv.text('Posible value: ' + precursorDef.exampleValue);
    }
    content.append(descrDiv);
    content.append(useDiv);
    content.append(defDiv);
    content.append(valDiv);
    return makeDependencyBox(issue, precursorDef, trail, span, content);
}

function makeInformerBox(issue, informer, trail, span) {
    const content = $('<div class="issue"/>');
    const codeSpan = $('<span class="informer"/>');
    codeSpan.text(getSourceFor(informer));
    content.append(codeSpan);
    const descr = $('<div />');
    descr.text(informer.descr);
    content.append(descr);
    return makeDependencyBox(issue, informer, trail, span, content);
}

function makeDependencyBox(issue, dependency, trail, span, content) {
    const box = $('<div />');
    box.append(content);
    box.on('click', () => displayIssueInformation(issue, trail.concat([{box, span}]), dependency));
    return box;
}

function getEnablers(issue, enablerId) {
    let enablerTable = {};
    for (const enabler of issue.enablers) {
        enablerTable[enabler.id] = enabler;
    }
    const enablers = [];
    while (enablerId !== null && enablerId !== undefined) {
        let enabler = enablerTable[enablerId];
        enablers.push(enabler);
        enablerId = enabler.dependencies.enablerId;
    }
    enablers.reverse();
    return enablers;
}

function makeEnablerList(issue, lastEnablerId, trail) {
    const enablers = getEnablers(issue, lastEnablerId);
    let enablerN = 1;
    const list = [];
    for (const enabler of enablers) {
        const enablerSpan = cmSmartSpan(enabler.location);
        const labelStyle = 'enabler-start' + enablerN;
        const enablerBox = makeEnablerBox(issue, enabler, trail, enablerSpan, labelStyle);
        list.push({enablerSpan, enablerBox, labelStyle});
        ++enablerN;
        if (10 <= enablerN) {
            enablerN = 9;
        }
    }
    return list;
}

function drawArrowsThroughEnablerChain(enablerList, cm, nodeLoc) {
    cm.drawingCtx.strokeStyle = enablerArrowColor;
    cm.drawingCtx.fillStyle = enablerArrowColor;
    cm.drawingCtx.lineWidth = 1;
    const nodeCoords = cmCoords(cm, cmBegin(nodeLoc.begin));
    var toX = nodeCoords.left;
    var toY = nodeCoords.top;
    for (const {enablerSpan: {begin}} of enablerList.slice().reverse()) {
        const {left, top} = cmCoords(cm, begin);
        const fromX = left;
        const fromY = top;
        drawArrow(cm, fromX - 10, fromY, toX - 10, toY, -100);
        toX = fromX;
        toY = fromY;
    }
}

function displayEnablers(enablerList, cm, nodeLoc) {
    clearEnablers();
    let enablerN = 1;
    for (const {enablerSpan, enablerBox, labelStyle} of enablerList) {
        const marker = cm.doc.markText(enablerSpan.begin, enablerSpan.end,
                                       {className: 'enabler', startStyle: labelStyle});
        markedEnablers.push({marker, span:enablerSpan, onClick: () => enablerBox.trigger('click')});
    }

    drawArrowsThroughEnablerChain(enablerList, cm, nodeLoc);
}

function clearEnablers() {
    for (const {marker} of markedEnablers) {
        marker.clear();
    }
    markedEnablers = [];
}

function displayIssuesInCodeMirror(issues) {
    for (const editor of Object.values(files)) {
        editor.issues = [];
        editor.setOption('lint', false);
    }
    for (const {location: {file, begin, end}, message} of issues) {
        const from = cmBegin(begin);
        const to = cmEnd(end);
        files[file].issues.push({from, to, message, severity: 'warning'});
    }
    for (const editor of Object.values(files)) {
        editor.setOption('lint', true);
    }
}

function makeIssueBox(issue) {
    const {ruleId, primaryLocation: {message, location}} = issue;
    const issueBox = $(`<div class="issue">${message}<br><small>${ruleId}</small></div>`);
    issueBox.on('click', () => displayIssueInformation(issue, [{box:issueBox, span:cmSmartSpan(location)}], issue.primaryLocation));
    return issueBox;
}

function displayAllIssuesInIssueList() {
    clearEnablers();
    clearPrecursors();
    issueList.text('');
    for (const issue of data.issues) {
        issueList.append(makeIssueBox(issue));
    }
}

let markedPrecursors = [];

function clearPrecursors() {
    for (const precursor of markedPrecursors) {
        precursor.marker.clear();
    }
    markedPrecursors = [];
}

let markedTrail = [];

function clearMarkedTrail() {
    for (const {marker} of markedTrail) {
        marker.clear();
    }
    markedTrail = [];
}

let markedInformers = [];

function clearMarkedInformers() {
    for (const {marker} of markedInformers) {
        marker.clear();
    }
    markedInformers = [];
}

function getPrecursorTable(issue) {
    const table = {};
    for (const precursor of issue.precursors) {
        table[precursor.id] = precursor;
    }
    return table;
}

function makePrecursorList(issue, precursorUses, trail) {
    let precursorTable = getPrecursorTable(issue);
    const list = [];
    var colorCode = 0;
    for (const precursorUse of precursorUses) {
        const useSpan = cmSmartSpan(precursorUse.location);
        const precursor = precursorTable[precursorUse.id];
        const defSpan = cmSmartSpan(precursor.location);
        const precursorBox = makePrecursorBox(issue, precursorUse, precursor, trail, defSpan, colorCode);
        list.push({useSpan, defSpan, colorCode, precursorBox});
        ++colorCode;
        if (precursorArrowColors.length <= colorCode) {
            colorCode = 0;
        }
    }
    return list;
}

function makeInformerList(issue, node, trail) {
    const list = [];
    if (!node.hasOwnProperty('name')) {
        // Not a precursor, so no informers
        return list;
    }
    for (const informer of issue.informers) {
        if (informer.affectedValues.includes(node.id)) {
            const span = cmSmartSpan(informer.location);
            const informerBox = makeInformerBox(issue, informer, trail, span);
            list.push({informerBox, span});
        }
    }
    return list;
}

function selfReference(useSpan, defSpan) {
    return defSpan.begin.line == useSpan.begin.line && defSpan.begin.ch == useSpan.begin.ch;
}

function drawArrowsFromPrecursors(precursorList, cm) {
    cm.drawingCtx.lineWidth = 1;
    var curveFactor = 1;
    for (const {useSpan, defSpan, colorCode} of precursorList) {
        if (selfReference(useSpan, defSpan)) {
            continue;
        }
        cm.drawingCtx.strokeStyle = precursorArrowColors[colorCode];
        cm.drawingCtx.fillStyle = precursorArrowColors[colorCode];
        const useCoords = cmCoords(cm, useSpan.end);
        const toX = useCoords.left;
        const toY = useCoords.top;
        const defCoords = cmCoords(cm, defSpan.end);
        const fromX = defCoords.right;
        const fromY = defCoords.bottom;
        drawArrow(cm, fromX, fromY, toX, toY, curveFactor*40);
        ++curveFactor;
    }
}

function displayPrecursors(precursorList, cm) {
    clearPrecursors();
    for (const {useSpan, defSpan, colorCode, precursorBox} of precursorList) {
        const markerUse = cm.doc.markText(useSpan.begin, useSpan.end,
                                          {className: 'precursor-mention' + colorCode,
                                           startStyle: 'precursor-mention-start' + colorCode,
                                           endStyle: 'precursor-mention-end' + colorCode});
        const markerDef = cm.doc.markText(defSpan.begin, defSpan.end, {className: 'precursor-definition' + colorCode});
        const onClick = () => precursorBox.trigger('click');
        markedPrecursors.push({marker:markerUse, span:useSpan, onClick});
        markedPrecursors.push({marker:markerDef, span:defSpan, onClick});
    }
    drawArrowsFromPrecursors(precursorList, cm);
}

function cmCoords(cm, loc) {
    return cm.charCoords(loc, 'local');
}

// https://stackoverflow.com/questions/6576827/html-canvas-draw-curved-arrows
function drawArrowhead(ctx, locx, locy, angle, sizex, sizey) {
    var hx = sizex / 2;
    var hy = sizey / 2;
    ctx.translate((locx), (locy));
    ctx.rotate(angle);
    ctx.translate(-hx, -hy);

    ctx.beginPath();
    ctx.moveTo(0, 0);
    ctx.lineTo(0, 1*sizey);
    ctx.lineTo(1*sizex, 1*hy);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();

    ctx.translate(hx, hy);
    ctx.rotate(-angle);
    ctx.translate(-locx, -locy);
}

// returns radians
function findAngle(startx, starty, endx, endy) {
    return Math.atan2((endy - starty), (endx - startx));
}

function drawArrow(cm, fromx, fromy, tox, toy, drift) {
    const ctx = cm.drawingCtx;
    const attractorx = (fromx + tox)/2 + drift;
    const attractory = (fromy + toy)/2;
	  const ang = findAngle(attractorx, attractory, tox, toy);
    ctx.beginPath();
    ctx.moveTo(fromx, fromy);
    ctx.quadraticCurveTo(attractorx, attractory, tox, toy);
    ctx.stroke();
    drawArrowhead(ctx, tox, toy, ang, 6, 6);
}

function drawArrowsThroughTrail(trail, cm) {
    if (trail.length <= 1) return;
    cm.drawingCtx.strokeStyle = trailArrowColor;
    cm.drawingCtx.fillStyle = trailArrowColor;
    cm.drawingCtx.lineWidth = 2;
    const lastNode = trail[trail.length - 1].span.begin;
    const nodeCoords = cmCoords(cm, lastNode);
    var prevLine = lastNode.line;
    var fromX = nodeCoords.left;
    var fromY = nodeCoords.top;
    for (const {span: {begin}} of trail.slice(0, -1).reverse()) {
        if (begin.line == prevLine) continue;
        prevLine = begin.line;
        const {left, top} = cmCoords(cm, begin);
        const toX = left;
        const toY = top;
        drawArrow(cm, fromX, fromY, toX, toY, -30);
        fromX = toX;
        fromY = toY;
    }
}

function displayTrail(trail, cm) {
    clearMarkedTrail();
    for (const {box, span} of trail) {
        const marker = cm.doc.markText(span.begin, span.end, {className: 'trail'});
        markedTrail.push({marker, span, onClick: () => box.trigger('click')});
    }
    drawArrowsThroughTrail(trail, cm);
}

let focusMarker = null;

function displayIssueNode(issue, location, enablerList, precursorList, informerList, trail) {
    if (focusMarker) {
        focusMarker.clear();
    }
    const filename = location.file;
    const {begin, end} = cmSmartSpan(location);
    const cm = files[filename];
    clearCanvas(cm);
    focusMarker = cm.doc.markText(begin, end, {className: 'focus-node'});
    displayEnablers(enablerList, cm, location);
    displayPrecursors(precursorList, cm);
    displayTrail(trail, cm);
    displayInformers(informerList, cm, location);
}

function displayInformers(informerList, cm, nodeLoc) {
    clearMarkedInformers();
    for (const {informerBox, span} of informerList) {
        const marker = cm.doc.markText(span.begin, span.end, {className: 'informer'});
        markedInformers.push({marker, span, onClick: () => informerBox.trigger('click')});
    }
    drawArrowsFromInformers(informerList, cm, nodeLoc);
}

function drawArrowsFromInformers(informerList, cm, nodeLoc) {
    cm.drawingCtx.strokeStyle = informerArrowColor;
    cm.drawingCtx.fillStyle = informerArrowColor;
    cm.drawingCtx.lineWidth = 1;
    const nodeCoords = cmCoords(cm, cmBegin(nodeLoc.begin));
    const toX = nodeCoords.right;
    const toY = nodeCoords.bottom;
    for (const {span} of informerList) {
        const infCoords = cmCoords(cm, span.end);
        const fromX = infCoords.right;
        const fromY = infCoords.top;
        drawArrow(cm, fromX, fromY, toX, toY, 0);
    }
}

function clearCanvas(cm) {
    cm.drawingCtx.clearRect(0, 0, cm.display.lineDiv.offsetWidth, cm.display.lineDiv.offsetHeight);
}

function cmScroll(location) {
    const {file, begin: {line, column}} = location;
    const adjustedColumn = Math.max(0, column - 30);
    const adjustedLine = Math.max(0, line - 30);
    const offset = cmCoords(files[file], cmBegin({line: adjustedLine, column: adjustedColumn}));
    files[file].scrollTo(offset.left, offset.top);
}

function displayIssueInformation(issue, trail, mainItem) {
    cmScroll(mainItem.location);
    issueList.children().detach();
    const backLink = $('<a>Back to issue list</a>');
    backLink.on('click', displayAllIssuesInIssueList);
    issueList.append(backLink);
    let list = issueList;
    var first = true;
    for (const {box} of trail) {
        list.append(box);
        const nextList = $('<div class="dependency-list"></div>');
        list.append(nextList);
        list = nextList;
        if (first && 1 < trail.length) {
            list.append("<b>Explored points:</b><br>");
        }
        first = false;
    }

    const enablerList = makeEnablerList(issue, mainItem.dependencies.enablerId, trail);
    const precursorList = makePrecursorList(issue, mainItem.dependencies.precursors, trail);
    const informerList = makeInformerList(issue, mainItem, trail);
    displayIssueNode(issue, mainItem.location, enablerList, precursorList, informerList, trail);
    const {enablerId, precursors} = mainItem.dependencies;

    if (0 < enablerList.length) {
        list.append(`<b>Conditions leading to the point:</b><br>`);
        const enablerBoxList = $('<div class="dependency-list"></div>');
        for (const {enablerBox} of enablerList) {
            enablerBoxList.append(enablerBox);
        }
        list.append(enablerBoxList);
    }

    if (0 < precursors.length) {
        list.append(`<b>Relevant values:</b><br>`);
        const precursorBoxList = $('<div class="dependency-list"></div>');
        for (const {precursorBox} of precursorList) {
            precursorBoxList.append(precursorBox);
        }
        list.append(precursorBoxList);
    }

    if (0 < informerList.length) {
        list.append(`<b>Assumptions about </b>`);
        // Non-empty informer list can only happen for a precursor, which has a "name" property.
        const nameSpan = $('<span class="precursor-mention0"/>');
        nameSpan.text(mainItem.name);
        list.append(nameSpan);
        list.append(`<b>:</b><br>`);
        const informerBoxList = $('<div class="dependency-list"></div>');
        for (const {informerBox} of informerList) {
            informerBoxList.append(informerBox);
        }
        list.append(informerBoxList);
    }
}

function isPositionBetween(begin, middle, end) {
    return ((begin.line < middle.line) || ((begin.line == middle.line) && (begin.ch <= middle.ch))) &&
        ((middle.line < end.line) || ((middle.line == end.line) && (middle.ch <= end.ch)));
}

function isPositionInSpan(pos, span) {
    return isPositionBetween(span.begin, pos, span.end);
}

// Returns true if the click was handled
function clickDispatchForList(pos, list) {
    for (const {span, onClick} of list) {
        if (isPositionInSpan(pos, span)) {
            onClick();
            return true;
        }
    }
    return false;
}

function cmClickDispatch(cm, event) {
    const pos = {line: event.line, ch: event.ch};
    if (clickDispatchForList(pos, markedPrecursors)) return;
    if (clickDispatchForList(pos, markedEnablers)) return;
    if (clickDispatchForList(pos, markedTrail)) return;
    if (clickDispatchForList(pos, markedInformers)) return;
}

for (const {name, contents} of data.files) {
    files[name] = makeCodeMirror(name, contents);
    files[name].setOption("extraKeys", {
        LeftClick: cmClickDispatch
    });
}
displayIssuesInCodeMirror(data.issues.map(issue => issue.primaryLocation));
displayAllIssuesInIssueList();
